import * as yup from "yup";

export const FLEET_VEHICLE_IMPORT_FORM_SCHEMA = yup.object().shape({
  files: yup
    .array()
    .required("Molimo Vas da dodate datoteku")
    .min(1, "Molimo Vas da dodate datoteku")
    .test(
      "is-xlsx",
      "Molimo Vas da priložite Excel datoteku (.xlsx). Predložak možete preuzeti klikom na gumb.",
      (files) => {
        if (!files) return false;

        return files.some((file: File) =>
          file.name.toLowerCase().endsWith(".xlsx")
        );
      }
    ),
});
